import jQuery from "jquery";

// simple extension of jQuery ready function that allows the creation of DOM-ready functions specific to pages
// borrowed from here https://github.com/Verba/jquery-readyselector/blob/c3356d0de7f3c969789ce9603ed3e76c56bbb195/jquery.readyselector.js
(function ($) {
    var ready = $.fn.ready;
    $.fn.ready = function (fn) {
        if (this.context === undefined) {
            // The $().ready(fn) case.
            ready(fn);
        } else if (this.selector) {
            ready($.proxy(function () {
                $(this.selector, this.context).each(fn);
            }, this));
        } else {
            ready($.proxy(function () {
                $(this).each(fn);
            }, this));
        }
    }
})(jQuery);
